function catchError(func) {
    return async (...args) => {
        try {
            const resultado = await func.apply(this, args);
            return resultado;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Ha ocurrido un error: ${ error }`);
        }
    };
}
export default catchError;
